import axios from "axios";
import { getConfig } from "../helpers/config";

export class IstitutoService {

  baseAPIUrl = `${getConfig()?.url}istituti`;

  findByCodice = async (codice) => {
    return await axios.get(`${this.baseAPIUrl}/codice/${codice}`)
											.then((res) => res.data);
  };
}
